import { mdiPencilRuler } from '@mdi/js'

export default {
  title: 'Bank Icon',
  icon: mdiPencilRuler,
  to: 'bank-icon',
  resource: 'BankIconAdmin',
  action: 'read',
}
